import classnames from "classnames";
import { Visible } from "util/enhancer";

type CheckBoxProps = {
  id: string;
  label: string;
  disabled?: boolean;
  checked: boolean;
  onChange: (value: boolean) => void;
  confirmType?: boolean;
  className?: string;
};

export const CheckBox = (props: CheckBoxProps) => {
  const classNames = classnames("check-box", props.className, {
    confirm: props.confirmType,
    "check-box-selected": props.checked,
  });
  return (
    <div className={classNames}>
      <div className="header">
        <input
          type="checkbox"
          id={props.id}
          disabled={props.disabled}
          checked={props.checked}
          aria-checked={props.checked}
          tabIndex={0}
          onChange={(evt) => props.onChange(evt.target.checked)}
        />
        <label htmlFor={props.id}>
          <span>{props.label}</span>
        </label>
      </div>
    </div>
  );
};

export const VisibleCheckBox = Visible(CheckBox);
